module.exports = __webpack_public_path__ + "img/source-of-fund.29d082d6.svg";